import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { Tag } from '@playbookux/playbook-web-core';
import {
  Container,
  ContainerTag,
  Content,
  Header,
  Link,
  MarginTag,
  Text,
} from './styles';

const CardHighlight = (props) => {
  const {
    cardType,
    children,
    color,
    createdAt,
    isFiltered,
    isSelectable,
    onCardClick,
    onClick,
    projectName,
    selected,
    tagHighlights,
    tagName,
    tagType,
    userName,
  } = props;

  return (
    <Container
      isSelectable={isSelectable}
      selected={selected}
      onClick={onCardClick}
    >
      <Header as="h3">
        {projectName}
      </Header>

      <Content>
        <Text withSpace>
          {userName}
        </Text>

        {tagName && isFiltered && (
          <Tag
            text={tagName}
            color={color}
            type={tagType}
          />
        )}

        {!_.isEmpty(tagHighlights) && (
          <ContainerTag>
            {_.map(tagHighlights, (tagHighlight) => (
              <MarginTag>
                <Tag
                  text={_.get(tagHighlight, 'tag.name', '')}
                  color={_.get(tagHighlight, 'tag.tagGroup.color', null)}
                  type={_.get(tagHighlight, 'tag.tagType', '')}
                />
              </MarginTag>
            ))}
          </ContainerTag>
        )}
      </Content>

      {children}

      {!isSelectable && (
        <Content footer>
          <Text date>
            {moment(createdAt).format('MMMM Do, YYYY')}
          </Text>
          <Text>
            <Link onClick={onClick}>
              {cardType}
            </Link>
          </Text>
        </Content>
      )}
    </Container>
  );
};

CardHighlight.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  color: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  onCardClick: PropTypes.func,
  isFiltered: PropTypes.bool,
  cardType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  projectName: PropTypes.string.isRequired,
  tagName: PropTypes.string,
  tagType: PropTypes.string,
  isSelectable: PropTypes.bool,
  selected: PropTypes.bool,
  tagHighlights: PropTypes.arrayOf(
    PropTypes.shape({
      charEnd: PropTypes.number,
      charStart: PropTypes.number,
      entityType: PropTypes.string,
      id: PropTypes.string,
      tag: PropTypes.shape({
        name: PropTypes.string,
        tagType: PropTypes.string,
      }),
    }),
  ),
};

CardHighlight.defaultProps = {
  color: null,
  tagName: null,
  tagHighlights: null,
  tagType: null,
  isFiltered: false,
  isSelectable: false,
  selected: false,
  onCardClick: () => { },
};

export default CardHighlight;
